<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: false,
      default: null,
    },
    tag: {
      type: [String, Object],
      required: false,
      default: 'div',
    },
  },
  computed: {
    isVisible() {
      if (this.currentIndex === null) {
        return false
      }
      return this.index <= this.currentIndex
    },
    classes() {
      return [
        'subslide',
        this.$style.subslide,
        this.isVisible ? this.$style.subslideVisible : null,
      ]
    },
  },
}
</script>
<template>
  <component :is="tag" :class="classes">
    <slot />
  </component>
</template>
<style lang="scss" module>
@import '@design';
.subslide {
  margin-bottom: 0;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  transform: translateY(40px);
  h4 {
    margin-bottom: 0;
  }
}
.subslideVisible {
  opacity: 1;
  transform: translateY(0);
}
</style>
